import React, { useState, useEffect, useRef } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNavigate, useParams } from "react-router-dom";
import AppTopBar2 from "./common/app-top-bar2";
import AppLoading from "./common/app-loading";
import EmailIcon from '@mui/icons-material/Email';
import EditIcon from '@mui/icons-material/Edit';
import PopInviteEmail from './pop-invite-email';
import {
  Button,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  Paper,
  Typography,
  Tooltip,
  Grid,
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import { AppHelper } from "../AppHelper";
import SpaCheck from "./common/spa-check";
import PopAccessRights from "./pop-access-rights";
import LinkOffIcon from '@mui/icons-material/LinkOff';
const dayjs = require("dayjs");
const configJson = require('../config.json?v=20230925');

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsTui = [
  { id: "i", numeric: false, disablePadding: false, label: "" },
  { id: "name", numeric: false, disablePadding: false, label: "NAME" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },
  { id: "accessTitle", numeric: false, disablePadding: false, label: "ACCESS" },
  { id: "status", numeric: true, disablePadding: false, label: "STATUS" },
  {
    id: "tCodeCreatedOn",
    numeric: true,
    disablePadding: false,
    label: "CREATED ON",
  },
  
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  
  const headCells = headCellsTui;
      
  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageTutorInvite() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();

  const [isLoading, setIsLoading] = useState(true);
  const [recProfile, setRecProfile] = useState({});
  const [profileList, setProfileList] = useState([]);
  const [originalProfileList, setOriginalProfileList] = useState([]);
  
  const [accList, setAccList] = useState([]);
  const [originalAccList, setOriginalAccList] = useState([]);
  const [tuiList, setTuiList] = useState([]);
  const [originalTuiList, setOriginalTuiList] = useState([]);
  
  const [tutList, setTutList] = useState([]);
  const [originalTutList, setOriginalTutList] = useState([]);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [viewMode, setViewMode] = React.useState("LIST-TUT");
  const [refreshList, setRefreshList] = React.useState(false);
  const [invitedTutor, setInvitedTutor] = React.useState(false); // used for refresh the list after tutor was invited in pop-invite
  const [countEssay, setCountEssay] = React.useState(0);
  const [countUser, setCountUser] = React.useState(0);
  const [countAcc, setCountAcc] = React.useState(0);
  const [countTui, setCountTui] = React.useState(0);
  const [countTut, setCountTut] = React.useState(0);
  const [countFeedback, setCountFeedback] = React.useState(0);
  
  const [tuiton, setTuiton] = React.useState("");
  
  const [tblOrderTut, setTblOrderTut] = React.useState("desc");
  const [tblOrderByTut, setTblOrderByTut] = React.useState("totalProfiles");
  const [filterTut, setFilterTut] = React.useState("");

  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  useEffect(() => {
    if (!oUser) {
      navigate("/login");
      return;
    }
  });

  const [isIncludeDeletedUser, setIsIncludeDeletedUser] = useState(false);
  const [isIncludeDeletedAcc, setIsIncludeDeletedAcc] = useState(false);
  const [isIncludeDeletedTui, setIsIncludeDeletedTui] = useState(false);
  const [isIncludeDeletedTut, setIsIncludeDeletedTut] = useState(false);
  const [popInviteEmailOpen, setPopInviteEmailOpen] = useState(false);
  const [popAccessRightsOpen, setPopAccessRightsOpen] = useState(false);

  useEffect(() => {
    var _list = originalTuiList.filter(
      (x) => x.status == 1 || isIncludeDeletedTui
    );
    setTuiList(_list);
    setCountTui(_list.length);
  }, [isIncludeDeletedTui]); 
  
  useEffect(() => {
    var _list = originalTutList.filter(
      (x) => x.status == 1 || isIncludeDeletedTui
    );
    setTutList(_list);
    setCountTut(_list.length);
  }, [isIncludeDeletedTut]); 
  useEffect(() => {
	  const fetchTutList = async () => {
      setIsLoading(true);
      var _list = [];
      var _res = await AppHelper.apiPost("api/account/tutor/listByCenter", {
        token: oUser.token,
      });
      setIsLoading(false);
      if (!_res || !_res.status) {
        return;
      }
      _res.data = _res.data.filter(r=>r.centerId==oUser.profileId);

      var _resAccept = await AppHelper.apiPost("api/tuition/tutor/list", {
        token: oUser.token,
      });
      if (!_resAccept || !_resAccept.status) {
        console.error("Failed to fetch accepted list. ");
        return;
      }
      _resAccept.data.forEach((aTutor) => {
        if (oUser.profileId === aTutor.centerId) {
          aTutor.accepted = true;
          _list.push(aTutor);
        }
      });

      var _resInvite = await AppHelper.apiPost("api/tuiton/invite/list", {
        token: oUser.token,
      });
      if (!_resInvite || !_resInvite.status) {
        console.error("Failed to fetch invited list. ");
        return;
      }
      _resInvite.data.forEach((invTutor) => {
        if (oUser.profileId === invTutor.centerId 
          && !_list.some(aTutor => aTutor.email.toLowerCase() === invTutor.email.toLowerCase())
        ) {
          invTutor.accepted = false;
          _list.push(invTutor);
        }
      });

      if(_resInvite && _resInvite.status){
      _res.data.forEach((item) => { 
        _resInvite.data.forEach((invTutor) => {
          if (item.profileId === invTutor.centerId && 
              invTutor.acceptedOn == null &&
              !_resAccept.data.some(aTutor => aTutor.email === invTutor.email )) {
            invTutor.accepted = false;
            _list.push(invTutor);
          }
        })
      });
      }
      _list.forEach((r, i) => {
        r.i = i;
        if (r.lastLogin) {
          var _ts = dayjs(r.lastLogin);
          r.lastLogin = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
          r.tCodeLastLogin = _ts.format("YYYYMMDDHHmmss");
        } else {
          r.lastLogin = "";
          r.tCodeLastLogin = "";
        }

        if (!AppHelper.isEmptyString(r.createdOn)) {
          var _ts = dayjs(r.createdOn);
          r.createdOn = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
          r.tCodeCreatedOn = _ts.format("YYYYMMDDHHmmss");
        } else {
          r.createdOn = "";
          r.tCodeCreatedOn = "";
        }
      });
      _list = [...AppHelper.sortList(_list, "totalProfiles", 2)];
	 
      setOriginalTutList(_list);
	  
      var _resAccess = await AppHelper.apiPost("api/access/all", {
        token: oUser.token,
      });
      var _gradeList=[
        {v:'P1', a:0}, {v:'P2', a:0}, {v:'P3', a:0},
        {v:'P4', a:0}, {v:'P5', a:0}, {v:'P6', a:0},
        {v:'S1', a:0}, {v:'S2', a:0}, {v:'S3', a:0},
        {v:'S4', a:0}, {v:'S4E', a:0}, {v:'S5', a:0},
      ];
      var _accessAll = (_resAccess && _resAccess.status && _resAccess.data) ? _resAccess.data : [];
      for(var i=0;i<_list.length; i++){
        var _recTutor = _list[i];
        var _accessArr = _accessAll.filter(r=>r.profileId==_recTutor.profileId);
        _recTutor.access = _gradeList.map(g => ({ ...g }));//[..._gradeList];
        _recTutor.access.forEach(a=>{
          var _access = _accessArr.find(r=>r.grade == a.v);
          if(_access) a.a = _access.access;
        });
      }
	
      setTutList(_list);
      setCountTut(_list.length);
    };
    const fetchIAM = async () => {
      if (!oUser) {
        navigate("/login");
        return;
      }
	  
	  var accountType = oUser.accountType || '';
	  
	  if(accountType != 'TUI')
	  {
		  var _res = await AppHelper.apiPost("api/account/iam", {
			token: oUser.token,
		  });
		  
		  if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
			setIsLoading(false);
			nonSaView();
			return;
		  }
	  }
	  
      fetchTutList();
    };
    fetchIAM();
    fetchTutList();
  }, [refreshList, invitedTutor]);
  
  const onInviteEmail = ()=>{
	setTuiton("");
    setPopInviteEmailOpen(true);    
    setInvitedTutor(false);
  }
  
  const popInviteEmailClose = ()=>{
	setTuiton("");
	setRefreshList(false);
    setPopInviteEmailOpen(false);
  }
  const onPopAccessRights = (arg)=>{
    setPopAccessRightsOpen(true);
    setRecProfile(arg);
  }
  const popAccessRightsClose = ()=>{
    setPopAccessRightsOpen(false);
  }
  
  const nonSaView = () => {
    setViewMode("NON-SA");
  };
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  
  const listSortAndFilterTut = () => {
    var _list = [...tutList];
    if (filterTut && filterTut.length > 0) {
      var _filterText = filterTut.toLowerCase();
      _list = _list.filter((r) => r.email.toLowerCase().includes(_filterText));
    }
    return stableSort(_list, getComparator(tblOrderTut, tblOrderByTut));
  };
  
  const visibleTuts = React.useMemo(
    () => listSortAndFilterTut(),
    [tutList, tblOrderTut, tblOrderByTut, filterTut]
  );
  
  const tblSortTut = (event, property) => {
    const isAsc = tblOrderByTut === property && tblOrderTut === "asc";
    setTblOrderTut(isAsc ? "desc" : "asc");
    setTblOrderByTut(property);
  };

  
  const handleRemoveTutor = async (row) => {        
    if(window.confirm("Are you sure to remove this tutor?")){
      setRefreshList(false);
      var _res = await AppHelper.apiPost('api/account/removeTutor', { email: row.email });
      if (!_res || !_res.status) {
        alert("Failed remove tutor!");
        setIsLoading(false);
        return;
      }
      alert("Successfully remove tutor!");
      setRefreshList(true);
    }
    };
  
  return (
    <>
    <Box sx={{ display: "flex" }}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading ? (
        <AppLoading />
      ) : (
        <>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: "100%",
              marginTop: "50px",
            }}
          >
			      {viewMode == "LIST-TUT" && (
              <>
                <Grid container>
                  {true  &&
                  <Button
                    onClick={() => onInviteEmail()}
                    className="app-btn-bg"
                    color="info"
                    variant="contained"
                    size="large"
                    style={{ marginRight: '2px', marginBottom: '8px' }} // Adjust the marginBottom value as needed
                    endIcon={<EmailIcon />}
                  >
                    SEND INVITE
                  </Button>
                  }
                </Grid>

                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <EnhancedTableHead
                      order={tblOrderTut}
                      orderBy={tblOrderByTut}
                      onRequestSort={tblSortTut}
                      gid="T1"
                      rowCount={tutList.length}
                    />
                    <TableBody>
                      {visibleTuts.map((row, iTut) => (
                        <TableRow
                          key={row.profileId}
                          sx={{
                            
                          }}
                        >
                          <TableCell align="center">{iTut + 1}</TableCell>
                          <TableCell align="left">{row.name}</TableCell>
						              <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">
                            {row.accountId &&
                            <>
                              { row.access && row.access.map(((recAcc,iAcc)=>(
                                <React.Fragment key={'chipAcc'+iAcc}>
                                  { (recAcc.a==1 || recAcc.a==2) &&
                                    <Chip label={recAcc.v} color="secondary" sx={{marginRight:'2px', 
                                      backgroundColor: recAcc.a==1?'#1976d2':'#138275'}} />
                                  }
                                </React.Fragment>
                              )))
                              }
                              <Tooltip title="access rights">
                                <IconButton onClick={() => onPopAccessRights(row)}>
                                <EditIcon style={{color:'#138275'}} />
                                </IconButton>
                              </Tooltip>
                            </>
                            }
                          </TableCell>
                          <TableCell align="right">
                            {!row.accepted?'INVITED':'ACTIVE'}
                          </TableCell>
                          <TableCell align="right">{row.createdOn?new Date(row.createdOn).toLocaleString() : ''}</TableCell>
                          <TableCell align="center">
                     
						 <IconButton 
							aria-label="Copy Invite Link" 
							onClick={() => {
							  navigator.clipboard.writeText(`${configJson.siteUrl}login/invite/${row.inviteId}`);
							  alert("Invite Link has been copied");
							}}
						  >
							<ContentCopyIcon />
						  </IconButton>

						  {row.accepted == true && 
                <IconButton aria-label="Remove tutors"  
                            onClick={() => handleRemoveTutor(row)} >
                  <LinkOffIcon />
                </IconButton>
              }
						   
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </Box>
        </>
      )}
      <SpaCheck></SpaCheck>
    </Box>
	  <PopInviteEmail
      tutList={tutList}
      open={popInviteEmailOpen} tuiton={tuiton} onClose={popInviteEmailClose}
      invitedTutor={setInvitedTutor}      
    />
	  <PopAccessRights profile={recProfile}
      open={popAccessRightsOpen} tuiton={tuiton} onClose={popAccessRightsClose}      
    />
    </>
  );
}
